import { EditableValue } from "src/components/BaseColumn";
import {
  KumaRequirementListDto,
  KumaViewDto,
  LanguageDto,
  OptionBasicDto,
  WorkflowDto,
} from "src/services/Client";
import {
  getRowStatusProps,
  parseWorkflowString,
} from "src/services/WorkflowUtils";
import IBaseOptionsRow from "../BaseOptionsView/BaseOptionsRow";

/**
 * Split a resource list response into option basic / standard equipment
 * and create corresponding rows. For the user the splits are
 * displayed in separate tables but are stored in the same DB.
 *
 * @param res the back end response to be split
 * @param languageList list of all languages known in the system
 * @param workflowList all workflows known to the system
 * @returns an object containing the two splits
 */
export const createRowsForKumaRequirement = (
  res: KumaRequirementListDto,
  languageList: LanguageDto[],
  workflowList: WorkflowDto[]
): KumaViewDto[] => {
  const rows: any[] = [];

  if (res.elements) {
    res.elements.forEach((element: OptionBasicDto) => {
      const info = parseWorkflowString(element.status, workflowList);
      if (info && info.editable !== EditableValue.Unvisible) {
        rows.push({
          ...element,
          ...getRowStatusProps(element.status, [], workflowList),
        });
      }
    });
  }
  return rows;
};



// WEBPACK FOOTER //
// ./src/views/KumaView/KumaRowUtils.ts